/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetBlueprintMetadataMetadataQueryResponse, GetBlueprintMetadataMetadataPathParams, GetBlueprintMetadataMetadataQueryParams, GetBlueprintMetadataMetadata400, GetBlueprintMetadataMetadata404 } from "../models/GetBlueprintMetadataMetadata";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getBlueprintMetadataMetadata } from "../axios/getBlueprintMetadataMetadata";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getBlueprintMetadataMetadataQueryKey = (reportType: GetBlueprintMetadataMetadataPathParams["reportType"], params: GetBlueprintMetadataMetadataQueryParams = {}) => ["audit-reports-api", { url: '/report-blueprints/:reportType', params: {reportType:reportType} }, ...(params ? [params] : [])] as const

export type GetBlueprintMetadataMetadataQueryKey = ReturnType<typeof getBlueprintMetadataMetadataQueryKey>

export function getBlueprintMetadataMetadataQueryOptions(reportType: GetBlueprintMetadataMetadataPathParams["reportType"], params?: GetBlueprintMetadataMetadataQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getBlueprintMetadataMetadataQueryKey(reportType, params)
        return queryOptions<GetBlueprintMetadataMetadataQueryResponse, ResponseErrorConfig<GetBlueprintMetadataMetadata400 | GetBlueprintMetadataMetadata404>, GetBlueprintMetadataMetadataQueryResponse, typeof queryKey>({
         enabled: !!(reportType),
         queryKey,
         queryFn: async ({ signal }) => {
            return getBlueprintMetadataMetadata(reportType, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Retrieves blueprint metadata (sections, categories, columns) for the specified report type. If blueprintVersion is provided, uses that version; otherwise uses the latest. The response excludes internal implementation details like extraction methods.
 * @summary Get blueprint metadata
 * {@link /report-blueprints/:reportType}
 */
export function useGetBlueprintMetadataMetadata<TData = GetBlueprintMetadataMetadataQueryResponse, TQueryData = GetBlueprintMetadataMetadataQueryResponse, TQueryKey extends QueryKey = GetBlueprintMetadataMetadataQueryKey>(reportType: GetBlueprintMetadataMetadataPathParams["reportType"], params?: GetBlueprintMetadataMetadataQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetBlueprintMetadataMetadataQueryResponse, ResponseErrorConfig<GetBlueprintMetadataMetadata400 | GetBlueprintMetadataMetadata404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getBlueprintMetadataMetadataQueryKey(reportType, params)
         

         const query = useQuery({
          ...getBlueprintMetadataMetadataQueryOptions(reportType, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetBlueprintMetadataMetadata400 | GetBlueprintMetadataMetadata404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}